<template>
  <div>
    <div v-if="is_super_admin" class="main-style">
      <div class="left-main">
        <div class="common-pidding">
          <el-tree 
          :data="l_department_tree_data"
          :props="defaultProps" 
          default-expand-all
          highlight-current-row
          :expand-on-click-node="false"
          @node-click="tree_click">
          </el-tree>
        </div>
      </div>

      <div class="right-main">
        <div class="search-style">
          <el-form :inline="true" :model="d_user_search" class="demo-form-inline" style="margin-top: 10 auto">
            
            <el-form-item label="用户名称" class="from-label" >
              <el-input size="small" v-model="d_user_search.username" placeholder="请输入用户名称" clearable></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search_user_func" size="small" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="on_reset" size="small" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <div style="margin-block: 16px; margin-left: 16px;">
          <el-button type="primary" icon="el-icon-plus"
          size="mini" plain
          @click="add_user"
          >新增用户</el-button>
        </div>
        
        <div style="common-pidding">
          <el-table
          :header-cell-style="{'background-color': '#f8f8f8', color: '#606266', fontFamily:'Helvetica',}"
          :data="l_table_data"
          border
          :fit="true"
          style="width: 100%">
          <el-table-column
            prop="username"
            align="center"
            label="用户名称"
            >
          </el-table-column>
          <el-table-column
            prop="phone_num"
            align="center"
            label="手机号"
            >
          </el-table-column>
         
          <el-table-column
            prop="department_name"
            align="center"
            label="部门"
            >
          </el-table-column>
          <el-table-column
            prop="job_name"
            align="center"
            label="岗位"
            width="380"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
             
              <el-tag type="info" v-for="(value, index) in scope.row.job_name" :key="index"  style='margin-left: 5px;'>
                <span>{{value}}</span>
              </el-tag>

            </template>
          </el-table-column>

          <el-table-column
            prop="user_status"
            align="center"
            label="超级管理员身份"
            width="150"
            >
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.is_super_admin == 1">超级管理员</el-tag>
              <el-tag type="primary" v-else>普通员工</el-tag>
            </template>
          </el-table-column>

          <el-table-column
            prop="email"
            align="center"
            label="邮箱"
            >
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="230" >

            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="user_show(scope.row)">查看</el-button>
              <el-button
                size="mini"
                @click="user_edit(scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="user_fire(scope.row)">解雇</el-button>
            </template>
          </el-table-column>

        </el-table>

        </div>
      </div>
    
    <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
        <el-button icon="el-icon-close" class='dialog-title-button' @click="b_show_dialog = false"></el-button>
        <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
      </div>

      <el-row :gutter="15">
        <el-form :model="d_dialog_data" ref="d_dialog_data" label-width="100px" @class="demo-d_dialog_data">
          
          <el-col :span="12">
            <el-form-item label='用户名' prop="username">
              <el-input v-model="d_dialog_data.username" placeholder="请输入用户名" :disabled="b_disabled"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label='邮箱' prop="email">
              <el-input v-model="d_dialog_data.email" placeholder="请输入邮箱" :disabled="b_disabled"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label='手机号' prop="phone_num">
              <el-input v-model="d_dialog_data.phone_num" placeholder="请输入手机号" :disabled="b_disabled"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label='密码' prop="password" v-show="password_disabled">
              <el-input v-model="d_dialog_data.password" placeholder="请输入密码" :disabled="b_disabled" ></el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label='部门' prop="department_id">
              
              <el-input type="text" v-model="d_dialog_data.department_name"
              placeholder="请选择部门" :disabled="b_disabled" 
              :style="{width: '100%'}" @focus="select_department"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="超级管理员" prop="is_super_admin">
              <el-switch v-model="d_dialog_data.is_super_admin" :disabled="b_disabled"></el-switch>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label='岗位' prop="job_list">
              <el-select v-model="d_dialog_data.job_list" multiple placeholder="请选择岗位" :disabled="b_disabled" :style="{width: '100%'}">
                <el-option
                  v-for="item in l_job_list"
                  :key="item.job_id"
                  :label="item.job_name"
                  :value="item.job_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="15">
            <el-form-item>
              <el-button type="primary" @click="submit_form()" :disabled="b_disabled">{{ s_dialog_btn_name }}</el-button>
              <el-button @click="cancel_func">取消</el-button> 
            </el-form-item>
          </el-col>
        </el-form>

      </el-row>
      

      

    </el-dialog>

    <el-dialog :visible.sync="b_department_dialog" :fullscreen="b_show_department_fullscreen" :before-close="this.$dialog_close" :show-close="false" width="500px">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">选择部门</span>
        <el-button icon="el-icon-close" class='dialog-title-button' @click="b_department_dialog = false"></el-button>
        <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_department_fullscreen = !b_show_fullscreen"></el-button>
      </div>
      
      <el-tree 
        :data="l_department_tree_data"
        :props="defaultProps" 
        default-expand-all
        highlight-current-row
        :expand-on-click-node="false"
        @node-click="select_department_func">
      </el-tree>

      <div class="common-pidding">
        <el-button type="primary" @click="select_department_submit">确定</el-button> 
        <el-button @click="select_department_cancel">取消</el-button> 
      </div>
    </el-dialog>



    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>
  </div>
    
</template>

<script>
export default {
  name : 'user_system',

  data() {
    return {
      d_user_search: {
        username: '',
      
      },

      l_table_data: [],

      // 弹窗相关数据
      b_show_dialog: false,
      b_show_fullscreen: false,
      b_disabled: false,
      s_dialog_name: '',
      s_dialog_btn_name: '',
      d_dialog_data: {},
      b_dialog_type: 1,
      password_disabled: false,

      // 岗位和部门相关数据
      l_job_list: [],
      l_department_data: [],
      l_department_tree_data: [],
      defaultProps:{children: 'children', label: 'department_name'},

      // 选择岗位弹窗
      b_department_dialog: false,
      b_show_department_fullscreen: false,
      s_select_department_name: '',
      s_select_department_id: '',

      is_super_admin: false,
    }
  },


  mounted() {
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    // 刷新部门数据并转换树结构
    this.ref_department_data()

    // 刷新用户列表
    this.ref_user_list()

    // 获取岗位列表
    this.ref_job_list()

  },


  methods: {
    // 获取岗位列表
    async ref_job_list(){
      let d_job_data = {'job_status': '正常'}
      let res = await this.$axios.get('/api/job/', {params: d_job_data})
      if(res.status == 200){
        this.l_job_list = res.data
      }
    },
    
    // 刷新用户列表
    async ref_user_list() {

      let d_user_data = {"is_business": 1}

      if (this.d_user_search.username != '') {
        d_user_data.username = this.d_user_search.username
      }
      
      let res = await this.$axios.get('/api/users/', {params: d_user_data})
      console.log(res)
      if (res.status == 200) {
        console.log(res)
        this.l_table_data = res.data
      }
     
    },

    // 刷新部门数据并转换为树结构
    async ref_department_data(){
      let d_query_data = {"department_detail": '正常'}
      let res = await this.$axios.get('/api/department/', {params: d_query_data})
      this.l_department_data = res.data
      this.l_department_tree_data = this.toTree(this.l_department_data, 'department_id', 'parent_id');
      
    },
     // 转换数据为树形结构
      toTree(objects, keyName, parentKeyName) {
 
        if (!keyName) {
          throw "keyName argument is required";
        }

        if (!parentKeyName) {
          throw "parentKeyName argument is required";
        }

        // 列表项字典 将数组变成以objectId分组的对象，类似于{Vvwkeujpo:{},Rohdsfdofj:{}}
        var map = {};
        objects.forEach(x => (map[x[keyName]] = Object.assign({}, x)));
        
        // 已添加到父项的键
        var pushed = {};

        // 遍历列表项，将子项添加到父项的 children 数组
        for (const key in map) {
          if (map.hasOwnProperty(key)) {// 这样就可以过滤掉原型链上的可枚举属性了
            const x = map[key];
            if (x && x[keyName] && x[parentKeyName]) {
              var parent = map[x[parentKeyName]];
              if (parent) {
                if (!parent.children) {
                  parent.children = [];
                }
                parent.children.push(x);
                pushed[x[keyName]] = true;
                }
              }
            }
          }
 
        // 排除已添加到父项的项得到树
        var tree = [];
          for (const key in map) {
            if (map.hasOwnProperty(key)) {
                const x = map[key];
                if (!pushed[x[keyName]]) {
                tree.push(x);
              }
            }
          }
        return tree;
      },

    // 选择部门
    select_department(){
      console.log(123)
      this.b_department_dialog = true
    },

    // 搜索
    search_user_func() {
      this.ref_user_list();
    },

    // 重置
    on_reset(){
      this.d_user_search = {
        username: '',
      }
      this.ref_user_list();
    },

    // 树结构点击事件
    tree_click(row){
      console.log(row)
      let s_department_id = row.department_id
      // 查询部门下的用户
      this.ref_user_list_by_department(s_department_id)
      
    },

    // 根据部门id查询用户
    async ref_user_list_by_department(s_department_id){
      
      // 获取部门子节点
      let l_department_child = this.get_department_child(s_department_id)
      
      // 递归获取所有子节点
      let l_department_child_all = []
      for(let i = 0; i < l_department_child.length; i++){
        let l_department_child_one = this.get_department_child(l_department_child[i])
        l_department_child_all = l_department_child_all.concat(l_department_child_one)
      }
      
      // 合并数据
      let l_department_id = l_department_child_all.concat(l_department_child)
      l_department_id.push(s_department_id)
     
      // 转为字符串
      let s_query_department_id = l_department_id.join(',')
      
      let d_user_data = {'l_department_id': s_query_department_id, 'is_business': 1}
      
      let res = await this.$axios.get('/api/users/', {params: d_user_data})
      console.log(res)
      if(res.status == 200){
        this.l_table_data = res.data
      }
    },

    // 获取部门子节点
    get_department_child(s_department_id){
      let l_department_child = []
      this.l_department_data.forEach(item => {
        if(item.parent_id == s_department_id){
          l_department_child.push(item.department_id)
        }
      })
      return l_department_child
    },

    // 新增用户
    add_user(){
      this.b_show_fullscreen = false
      this.b_show_dialog = true
      this.s_dialog_name = '新增用户'
      this.s_dialog_btn_name = '新增'
      this.b_dialog_type = 1
      this.password_disabled = true
      this.b_disabled = false
      this.d_dialog_data = {}
    },

    // 查看用户
    user_show(row){
      this.b_show_fullscreen = false
      this.b_show_dialog = true
      this.s_dialog_name = '查看用户'
      this.s_dialog_btn_name = '禁止操作'
      this.b_dialog_type = 3
      this.d_dialog_data = JSON.parse(JSON.stringify(row))  
      this.b_disabled = true
      this.password_disabled = false
    },

    // 编辑用户
    user_edit(row){
      this.b_show_fullscreen = false
      this.b_show_dialog = true
      this.s_dialog_name = '编辑用户'
      this.s_dialog_btn_name = '保存'
      this.b_dialog_type = 2
      this.d_dialog_data = JSON.parse(JSON.stringify(row))  
      this.password_disabled = false
      this.b_disabled = false
    },

    // 解雇用户
    user_fire(row){
      let data = row

      var _this = this
        this.$confirm('此操作将解雇该员工, 员工身份信息不回被删除, 将记录在普通用户中, 是否继续?', '解雇员工警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          data.is_business = 0
          data.is_super_admin = 0
          data.is_dismissal = true

          console.log(data)
          _this.$axios.patch('/api/users/' + row.id + '/', data).then(
            function(res){
              _this.$message({
                type: 'success',
                message: '解雇成功'
              });
              _this.ref_user_list()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消解雇'
          });          
        });

    },

    // 删除用户
    user_remove(row){
      console.log(row)
      var _this = this
        this.$confirm('是否删除此用户? 删除后此用户将不再拥有后台登录权限', '删除用户警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          _this.$axios.delete('/api/users/' + row.id + '/').then(
            function(res){
              _this.$message({
                type: 'success',
                message: '删除成功!'
              });
              _this.ref_user_list()
            }
          )
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    // 弹窗确认
    async submit_form(){
      console.log(this.d_dialog_data)
      
      if (this.b_dialog_type === 1) {
        let url = '/api/users/'
        // 'password_confirm': 'aa956956',
        let password_confirm = this.d_dialog_data.password

        // this.d_dialog_data.password_confirm = password_confirm
        this.$set(this.d_dialog_data, 'password_confirm', password_confirm)
        this.$set(this.d_dialog_data, 'is_business', 1)
        console.log(this.d_dialog_data)
        let res = await this.$axios.post(url, this.d_dialog_data)
        console.log(res)
        this.request_waring(res)
      }else if (this.b_dialog_type === 2){
        console.log(this.d_dialog_data)
        let url = '/api/users/' + this.d_dialog_data.id + '/'
        let res = await this.$axios.patch(url, this.d_dialog_data)
        console.log(res)
        this.request_waring(res)
      }
    },

    // 请求警告
    request_waring(res){
      if (res.status === 201 || res.status === 200){
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.b_show_dialog = false
        // 刷新表单数据
        this.ref_user_list()
      } else {
        this.$message({
          message: '保存失败',
          type: 'error'
        })
      }
    },


    // 弹窗取消
    cancel_func(){
      this.b_show_dialog = false
    },

    // 弹窗选择部门事件
    select_department_func(row){
      console.log(row)
      // this.b_department_dialog = false
      this.s_select_department_name = row.department_name
      this.s_select_department_id = row.department_id
      console.log(this.s_select_department_name)
    },

    // 弹窗选择岗位事件-确定
    select_department_submit(){
      console.log(this.s_select_department_name)
      this.b_department_dialog = false
      // this.d_dialog_data.set
      this.$set(this.d_dialog_data, 'department_name', this.s_select_department_name)
      this.$set(this.d_dialog_data, 'department_id', this.s_select_department_id)
    },

    // 弹窗选择岗位事件-取消
    select_department_cancel(){
      this.b_department_dialog = false
      this.s_select_department_name = ''
    }
  },
}
</script>

<style>

.main-style {
  background-color: #f3f3f4;
  height: 100%;
  /* position: absolute; */
  width: 100%;
  display: flex
}


.left-main {
  background-color: #fff;
  width: 280px;
  /* padding: 10px 16px; */
  border-left: 10px solid #f3f3f4;
  border-right: 5px solid #f3f3f4;
  border-top: 10px solid #f3f3f4;
  border-bottom: 10px solid #f3f3f4;
  height: calc(100% - 20px);
  
}

.right-main {
  /* padding: 10px 16px; */
  background-color: #fff;
  /* margin-left: 20px; */
  border-left: 5px solid #f3f3f4;
  border-right: 10px solid #f3f3f4;
  border-top: 10px solid #f3f3f4;
  border-bottom: 10px solid #f3f3f4;
  height: calc(100% - 20px);
  width: calc(100% - 280px);
}

.common-pidding {
  padding: 10px 16px;
}

.search-style {
  margin-top: 16px;
  margin-left: 16px;
}

.from-label {
  
  font-weight: 700;
  color: #606266;
  /* font-size:14px; */
  padding: 0 12px 0 0; 
  text-align: right; 
  vertical-align: middle;
  margin-bottom: 22px;
}

</style>
